import { render, staticRenderFns } from "./ModulrSortCodeBanner.vue?vue&type=template&id=a2f232c2&"
import script from "./ModulrSortCodeBanner.vue?vue&type=script&lang=js&"
export * from "./ModulrSortCodeBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports